import React from 'react'
import { graphql } from "gatsby"
import { GatsbyImage, IGatsbyImageData, getImage } from "gatsby-plugin-image"
import * as styles from "./Image.css"
import {
  Card,
} from "../ui"

export type ImageProps = {
  image: {
    title: string
    gatsbyImageData: any
  }
  link?: string
  attribution: boolean
  roundedCorners: boolean
}

export default function Image(props: ImageProps) {
  
  const image = (
    <>
    {props.link ? (
      <a href={props.link}>
        <GatsbyImage
          alt={props.image.title}
          className={styles.image}
          image={getImage(props.image)}
        />
      </a>
    ) : (
      <GatsbyImage
        alt={props.image.title}
        className={styles.image}
        image={getImage(props.image)}
      />
    )}
    </>
  )

  return (
    <div>
      {props.roundedCorners ? (
        <Card>
          {image}
        </Card>
      ): image}
      <div className={styles.photoCredit}>
        {props.attribution && <small>{props.attribution}</small>}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ImageContent on Image {
    desktopRight
    roundedCorners
    link
    image {
      title
      ... on DatoCmsAsset {
        gatsbyImageData(
          imgixParams: {w: "1200"}
        )
      }
    }
    attribution
  }
`